import { ReactNode } from "react";

export default function ExpeditionChapterHeading({ number, label, id, title, technology }: {
  number: string; label: string; id?: string; title: ReactNode; technology: ReactNode;
}) {
  return <div className="expedition-case-heading">
    <span className="expedition-chapter-number" aria-hidden="true">{number}</span>
    <div className="expedition-chapter-title"><span className="expedition-kicker">{label}</span><h3 id={id}>{title}</h3><p className="expedition-tech">{technology}</p></div>
  </div>;
}
